import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB3-U9-P62-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page62/E1/1.jpg' },
      ]
    ]
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'WB3-U9-P62-E2',
    audio: 'img/FriendsPlus/Page62/Audio/audio-e2-p62.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page62/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page62/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page62/Audio/tieude-e2-p62.mp3' },
        { url: 'img/FriendsPlus/Page62/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page62/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page62/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/6.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page62/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/8.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page62/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/10.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page62/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page62/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page62/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/14.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page62/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/16.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page62/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/18.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page62/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/20.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page62/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/22.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page62/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page62/E2/24.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page62/E2/25.jpg' },
      ],
    ]
  },



}
export default json;